import { keyBy, compose, get } from 'lodash/fp';
import { createSelector } from 'reselect';
import { combineReducers } from 'redux';
import { createAsyncActionTypes, createReducer, createAction, createAsyncMetaSelectors } from '@mews/framework';
import { ApplicationState, AsyncAction, CommanderThunkAction, WithEnterpriseId } from '@mews-commander/types';
import { CurrencyAcceptance } from '@mews-commander/data-access';
import { createFetchAction } from '@mews-commander/utils';
import prefix from '../prefix';
import moduleSelector from '../selector';
import { createBaseGetEntitiesSelector } from './utils';

export const EXCHANGE_RATES_FETCH = prefix('EXCHANGE_RATES_FETCH');
export const [EXCHANGE_RATES_FETCH_STARTED, EXCHANGE_RATES_FETCH_SUCCEEDED, EXCHANGE_RATES_FETCH_FAILED] =
    createAsyncActionTypes(EXCHANGE_RATES_FETCH);
export const EXCHANGE_RATES_CHANGE = prefix('EXCHANGE_RATES_CHANGE');
export const [EXCHANGE_RATES_CHANGE_STARTED, EXCHANGE_RATES_CHANGE_SUCCEEDED, EXCHANGE_RATES_CHANGE_FAILED] =
    createAsyncActionTypes(EXCHANGE_RATES_CHANGE);
export const EXCHANGE_RATES_ADD = prefix('EXCHANGE_RATES_ADD');

export function fetchRates({ enterpriseId }: WithEnterpriseId): CommanderThunkAction<AsyncAction> {
    return async (dispatch, getState, { container }) => {
        const promise = container().exchangeRateComponent.getAll(enterpriseId);
        return dispatch(createFetchAction(EXCHANGE_RATES_FETCH, { promise }));
    };
}

export function addRate(enterpriseId: $TSFixMe, currencyCode: $TSFixMe) {
    return (dispatch: $TSFixMe, getState: $TSFixMe, { container }: { container: () => CommanderContainer }) => {
        const promise = container().exchangeRateComponent.add(enterpriseId, currencyCode);
        return dispatch(createFetchAction(EXCHANGE_RATES_ADD, { promise }));
    };
}

export function changeRates(enterpriseId: $TSFixMe, acceptances: $TSFixMe) {
    return (dispatch: $TSFixMe, getState: $TSFixMe, { container }: { container: () => CommanderContainer }) => {
        const promise = container()
            .exchangeRateComponent.updateRates(enterpriseId, acceptances)
            .then(() => acceptances);

        return dispatch(createAction(EXCHANGE_RATES_CHANGE, { promise }));
    };
}

export const NAME = 'exchangeRates';

const initialDataState = {
    exchangeRates: {},
};

const initialMetaState = {
    isFetching: false,
    hasFailed: false,
};

export const keyByCurrencyCode = keyBy('currencyCode');

export const exchangeRateDataReducer = createReducer(initialDataState, {
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [EXCHANGE_RATES_FETCH_SUCCEEDED]: (state, payload) => ({
        ...keyByCurrencyCode(payload),
    }),
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [EXCHANGE_RATES_CHANGE_SUCCEEDED]: (state, payload) => ({
        ...state,
        ...keyByCurrencyCode(payload),
    }),
});

export const exchangeRateMetaReducer = createReducer(initialMetaState, {
    [EXCHANGE_RATES_FETCH_STARTED]: () => ({
        hasFailed: false,
        isFetching: true,
    }),
    [EXCHANGE_RATES_FETCH_SUCCEEDED]: () => ({
        hasFailed: false,
        isFetching: false,
    }),
    [EXCHANGE_RATES_FETCH_FAILED]: () => ({
        hasFailed: true,
        isFetching: false,
    }),
    [EXCHANGE_RATES_CHANGE_STARTED]: () => ({
        hasFailed: false,
        isFetching: true,
    }),
    [EXCHANGE_RATES_CHANGE_SUCCEEDED]: () => ({
        hasFailed: false,
        isFetching: false,
    }),
    [EXCHANGE_RATES_CHANGE_FAILED]: () => ({
        hasFailed: true,
        isFetching: false,
    }),
});

export default combineReducers({
    exchangeRates: exchangeRateDataReducer,
    metaState: exchangeRateMetaReducer,
});

const getModuleState = createSelector(moduleSelector, (state) => state[NAME]);

const getModuleMeta = compose(get('metaState'), getModuleState);
export const [isFetchingExchangeRates] = createAsyncMetaSelectors(getModuleMeta);

export const getExchangeRates = createBaseGetEntitiesSelector<ApplicationState, CurrencyAcceptance, 'exchangeRates'>(
    getModuleState,
    'exchangeRates'
);
